module.exports = "https://coursera_assets.s3.amazonaws.com/images/9d435fe9e940e139c5d30cdaa4dd9656.png";